import { AnalyticEvents } from '@app/enums';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { CheckListItem } from '@app/modules/table/classes/column-filters/check-list/check-list-item.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { DropdownColumn } from '@app/modules/table/interfaces/dropdown-column.interface';
import { InteractableColumn } from '@app/modules/table/interfaces/interactable-column.interface';
import { AnalyticService } from '@app/services';
import { JobFunnelNameOptions } from '@app/types/translatables/applicant-tracker/job-funnel-name.options';
import { Applicant } from '@models/recruiting/applicant.model';
import { JobFunnel } from '@models/recruiting/job-funnel.model';
import { JobPosting } from '@models/recruiting/job-posting.model';

export class JobFunnelColumn extends Column implements InteractableColumn, DropdownColumn {
    title = 'applicant-tracker.applicants-table.job-funnel';
    property = 'rating';
    sortField = 'rating';
    sortable = true;
    type: CellDisplay = CellDisplay.dropdown;

    constructor(
        protected companyId: number,
        private analyticService: AnalyticService,
        private pendoEvent: AnalyticEvents,
        private jobPostingId?: number
    ) {
        super();

        if (this.jobPostingId) {
            const jobFunnelsQuery = JobFunnel.orderBy('funnelIndex', 'ASC').where('jobId', this.jobPostingId).all();
            const options = jobFunnelsQuery.then(
                ([jobFunnels]) =>
                    Array.from(
                        jobFunnels.reduce((accumulator) => {
                            jobFunnels.forEach((jobFunnel: JobFunnel) => accumulator.add(jobFunnel.funnelStep));
                            return accumulator;
                        }, new Set())
                    ).map((funnelStep) => ({ label: funnelStep, value: funnelStep })) as CheckListItem[]
            );
            this.filter = new CheckListFilter('jobFunnelStepName', options);
            return;
        }

        const regularPostingQuery = JobPosting.param('company', this.companyId)
            .orderBy('title', 'ASC')
            .with('jobFunnels')
            .all();
        const options = regularPostingQuery.then(
            ([jobPostings]) =>
                Array.from(
                    jobPostings.reduce((accumulator, jobPosting: JobPosting) => {
                        jobPosting.jobFunnels.forEach((jobFunnel: JobFunnel) => accumulator.add(jobFunnel.funnelStep));
                        return accumulator;
                    }, new Set())
                ).map((funnelStep) => ({ label: funnelStep, value: funnelStep })) as CheckListItem[]
        );
        this.filter = new CheckListFilter('jobFunnelStepName', options);
    }

    getDropdownOptions(applicant: Applicant) {
        return applicant.jobPosting.jobFunnels
            .sort((a: JobFunnel, b: JobFunnel) => a.funnelIndex - b.funnelIndex)
            .map((jobFunnel) => ({
                label: JobFunnelNameOptions[jobFunnel.funnelStep] ?? jobFunnel.funnelStep,
                value: jobFunnel.id,
            }));
    }

    getBindProperty(_applicant: Applicant) {
        return 'jobFunnelId';
    }

    onRowChange(row: any): void {
        this.analyticService.trackEvent(this.pendoEvent);
        row.param('company', row.companyId).save();
    }
}
